import {EnderecoSuper} from './endereco-super';
import {Endereco} from './endereco';
import {Construtor} from './construtor';

export class EnderecoCliente extends EnderecoSuper implements Construtor<EnderecoCliente> {

  public idEnderecoCliente: number;

  public idCliente: number;

  public alterado: boolean;

  constructor(object?: any) {
    super();
    this.endereco = new Endereco();
    if (object !== undefined && object !== null) {
      if (object instanceof EnderecoCliente) {
        this.copyObject(object);
      } else if (object instanceof Endereco) {
        this.Endereco = object;
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
    return this;
  }

  get obterIdEnderecoCliente(): number {
    return this.idEnderecoCliente;
  }

  set IdEnderecoCliente(idEnderecoCliente: any) {
    this.idEnderecoCliente = idEnderecoCliente;
  }

  copyObject(enderecoCliente: EnderecoCliente): void {
	this.idEnderecoCliente = enderecoCliente.obterIdEnderecoCliente;
	this.idCliente = enderecoCliente.idCliente;
    this.Endereco = enderecoCliente.endereco;
  }

  parseFromJson(enderecoCliente: any): void {
    this.IdEnderecoCliente = enderecoCliente.idEnderecoCliente;
	this.idCliente = enderecoCliente.idCliente;
    this.Endereco = enderecoCliente.endereco;
  }

  modeloCompleto(): boolean {
    return this.endereco.modeloCompleto();
  }

  getNewInstance(object?: any): EnderecoCliente {
    return new EnderecoCliente(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/endereco-cliente.ts